import { render, staticRenderFns } from "./tableMess.vue?vue&type=template&id=c4ea1c76&scoped=true&slot-scope=scope&"
import script from "./tableMess.vue?vue&type=script&lang=js&"
export * from "./tableMess.vue?vue&type=script&lang=js&"
import style0 from "./tableMess.vue?vue&type=style&index=0&id=c4ea1c76&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ea1c76",
  null
  
)

export default component.exports